export enum encryptKeys {
  tradeKey = 'tradeKey'
}
